window.addEventListener('load', function () {

	const swiper2 = new Swiper('.swiper-2', {
		// Optional parameters
		direction: 'horizontal',
		loop: true,

		spaceBetween: 25,

		navigation: {
			nextEl: '.swiper-next',
			prevEl: '.swiper-prev',
		},
	});

	if (this.window.location.pathname == '/blog/') {
		const swiper1 = new Swiper('.swiper-1', {
			// Optional parameters
			direction: 'horizontal',
			loop: true,

			spaceBetween: 25,

			navigation: {
				nextEl: '.swiper-next',
				prevEl: '.swiper-prev',
			},
		});



		const api = new GhostContentAPI({
			url: 'https://pharmafootpath.com',
			key: '420eff2e17c684c07b6c29864a',
			version: "v5.0"
		});

		let cardTemplate =
			`
		<article class="card">
			{{#if feature_image}}
				<a href="{{url}}">
					<div class="card__image-box">
						<img src="{{feature_image}}" alt="post image" class="card__image">
						<div class="big-card__tag">{{tags.0.name}}</div>
					</div>
				</a>
			{{else}}
				<a href="{{url}}">
					<div class="card__image-box">
						<img src="../assets/images/placeholder.webp" alt="post image" class="card__image">
						<div class="big-card__tag">{{tags.0.name}}</div>
					</div>
				</a>
			{{/if}}
			<div class="card__text">
				<h3 class="card__title">{{title}}</h3>
				<div class="card__content">{{excerpt}}</div>
			</div>
			<a href="{{url}}" class="card__read-more">Read Article<img src="../assets/images/right-arrow.svg" alt="right arrow"></a>
		</article>
	
		`
		let compiledCardTemplate = Handlebars.compile(cardTemplate);
		let postsBlock = document.querySelector('.blog-body__posts')
		let categoriesBtns = document.querySelectorAll('.body-filter__btn')
		let allPostsBtn = document.querySelector('.all-posts-btn');
		let newsPostsBtn = document.querySelector('.news-btn');
		let showCatBtn = document.querySelector('.show-categories-btn')
		let catBlock = document.querySelector('.body-filter__categories')
		let bodyFilterArrow = document.querySelector('.body-filter__arrow')
		let catPlaceholder = document.querySelector('.category-placeholder')
		let postsBody = document.querySelector('.blog-body')
		let postsLimit = 3;
		let postsDefault = 3;

		let mobileSettingsBtn = document.querySelector('.mobile-posts-settings');
		let mobileSettingsCat = document.querySelector('.mobile-settings-categories')
		// let loadMoreBtn = createLoadMore();

		showAllPosts();
		getCategories();
		getCategoriesMobile()
		mobileSettings();


		function mobileSettings() {

			mobileSettingsBtn.addEventListener('click', function () {
				mobileSettingsBtn.classList.toggle('mobile-settings-active')
			})
		}


		function createLoadMore() {
			let loadMoreDiv = document.createElement('div')
			loadMoreDiv.innerText = 'load more';
			loadMoreDiv.classList.add('blog-body__load-more')

			return loadMoreDiv;
		}

		function clearCategories() {
			categoriesBtns.forEach(element => {
				element.classList.remove('body-filter__btn_active')
			});
			showCatBtn.classList.remove('body-filter__btn_active');
			bodyFilterArrow.setAttribute('src', '../assets/images/arrow-down.svg')
			catBlock.classList.remove('body-filter__categories_active')
			catPlaceholder.innerText = 'Categories'
			showCatBtn.classList.remove('showCatActive')
		}

		function getCategoriesMobile() {
			let categorieDiv = document.createElement("div");
			categorieDiv.classList.add('body-filter__categorie');
			categorieDiv.innerHTML = "Show all";
			categorieDiv.addEventListener('click', showAllPosts)
			mobileSettingsCat.appendChild(categorieDiv)

			api.tags
				.browse()
				.then((tags) => {
					tags.forEach(element => {
						let categorieDiv = document.createElement("div");
						categorieDiv.classList.add('body-filter__categorie');
						categorieDiv.innerHTML = element.name;
						categorieDiv.addEventListener('click', function () {

							postsDefault = postsLimit;

							api.posts
								.browse({ include: "tags", filter: `tag:${element.slug}`, limit: postsDefault })
								.then((posts) => {
									postsBlock.innerHTML = ''
									posts.forEach(element => {
										postsBlock.innerHTML += compiledCardTemplate(element)
									});

									loadMoreBtnFunc(element.slug)
								})
								.catch((err) => {
									console.error(err);
								});
						});
						mobileSettingsCat.appendChild(categorieDiv)
					});
					return mobileSettingsCat;
				})
				.catch((err) => {
					console.error(err);
				});
		}

		function getCategories() {
			api.tags
				.browse()
				.then((tags) => {
					tags.forEach(element => {
						if (element.name != 'News') {
							let categorieDiv = document.createElement("div");
							categorieDiv.classList.add('body-filter__categorie');
							categorieDiv.innerHTML = element.name;
							categorieDiv.addEventListener('click', function () {

								postsDefault = postsLimit;
								categoriesBtns.forEach(element => {
									element.classList.remove('body-filter__btn_active')
								});

								catPlaceholder.innerText = element.name;
								showCatBtn.classList.add('body-filter__btn_active');
								bodyFilterArrow.setAttribute('src', '../assets/images/arrow-down-white.svg')
								catBlock.classList.add('body-filter__categories_active')

								api.posts
									.browse({ include: "tags", filter: `tag:${element.slug}`, limit: postsDefault })
									.then((posts) => {
										postsBlock.innerHTML = ''
										posts.forEach(element => {
											postsBlock.innerHTML += compiledCardTemplate(element)
										});

										loadMoreBtnFunc(element.slug)
									})
									.catch((err) => {
										console.error(err);
									});
							});
							catBlock.appendChild(categorieDiv)
						}
					});
					return catBlock;
				})
				.catch((err) => {
					console.error(err);
				});
		}

		function showAllPosts() {
			postsDefault = postsLimit;
			clearCategories();
			allPostsBtn.classList.add('body-filter__btn_active')

			api.posts
				.browse({ include: "tags", limit: postsLimit })
				.then((posts) => {
					postsBlock.innerHTML = ''
					posts.forEach(element => {
						postsBlock.innerHTML += compiledCardTemplate(element)
					});
				})
				.catch((err) => {
					console.error(err);
				});

			noTagLoadMoreBtnFunc();
		}

		newsPostsBtn.addEventListener('click', function () {
			postsDefault = postsLimit;
			clearCategories();
			newsPostsBtn.classList.add('body-filter__btn_active')

			api.posts
				.browse({ include: "tags", filter: "tag:news", limit: postsLimit })
				.then((posts) => {
					postsBlock.innerHTML = ''
					posts.forEach(element => {
						postsBlock.innerHTML += compiledCardTemplate(element)
					});
				})
				.catch((err) => {
					console.error(err);
				});

			loadMoreBtnFunc('news')
		})

		allPostsBtn.addEventListener('click', function () {
			showAllPosts();
			clearCategories();
			allPostsBtn.classList.add("body-filter__btn_active");
		})

		showCatBtn.addEventListener('click', function () {
			showCatBtn.classList.toggle('showCatActive')
		})


		function loadMoreBtnFunc(selectedTag) {
			api.posts
				.browse({ filter: `tag:${selectedTag}` })
				.then((posts) => {
					let prevLoadMoreBtn = document.querySelectorAll('.blog-body__load-more')
					prevLoadMoreBtn.forEach(element => {
						element.remove();
					});

					if (posts.length > postsDefault) {

						let loadMoreBtn = createLoadMore();
						postsBody.appendChild(loadMoreBtn)
						loadMoreBtn.addEventListener('click', function () {
							postsDefault += 3;
							api.posts
								.browse({ include: "tags", limit: postsDefault, filter: `tag:${selectedTag}` })
								.then((posts) => {
									postsBlock.innerHTML = ''
									posts.forEach(element => {
										postsBlock.innerHTML += compiledCardTemplate(element)
									});
								})
								.catch((err) => {
									console.error(err);
								});
							loadMoreBtn.remove();
							loadMoreBtnFunc()
						}, { once: true })
					}

				})
				.catch((err) => {
					console.error(err);
				});
		}

		function noTagLoadMoreBtnFunc() {
			api.posts
				.browse()
				.then((posts) => {
					let prevLoadMoreBtn = document.querySelectorAll('.blog-body__load-more')
					prevLoadMoreBtn.forEach(element => {
						element.remove();
					});

					if (posts.length > postsDefault) {

						let loadMoreBtn = createLoadMore();
						postsBody.appendChild(loadMoreBtn)
						loadMoreBtn.addEventListener('click', function () {
							postsDefault += 3;
							api.posts
								.browse({ include: "tags", limit: postsDefault })
								.then((posts) => {
									postsBlock.innerHTML = ''
									posts.forEach(element => {
										postsBlock.innerHTML += compiledCardTemplate(element)
									});
								})
								.catch((err) => {
									console.error(err);
								});
							loadMoreBtn.remove();
							noTagLoadMoreBtnFunc()
						}, { once: true })
					}

				})
				.catch((err) => {
					console.error(err);
				});
		}
	}
})

document.getElementById('copyright').appendChild(document.createTextNode(new Date().getFullYear()))